import { Vibration } from 'react-native';
export const Vibrate = {
    formSubmitted() {
        Vibration.vibrate([10, 10], false);
    },
};
